var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Apptab'),_c('v-container',[_c('h1',[_vm._v("participants")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getHeaders(),"items":_vm.participants,"items-per-page":10},scopedSlots:_vm._u([{key:"item.email",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.email === 'null'?'':item.email)+" ")]}},{key:"item.phone",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.phone === 'null'?'':item.phone)+" ")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }